module.exports = __webpack_public_path__ + "static/img/andoridDownload.b2480653.png";